var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paziente-terapia-list-component',{key:_vm.keyTerapiaAttiva,attrs:{"elements":_vm.elements,"dataRiferimento":_vm.dataRiferimento},on:{"update":_vm.onRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }